import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row-top" }
const _hoisted_2 = {
  key: 0,
  class: "dose-grid"
}
const _hoisted_3 = {
  key: 0,
  class: "col"
}
const _hoisted_4 = {
  key: 0,
  style: {"grid-column":"span 3","align-self":"start"}
}
const _hoisted_5 = { style: {"max-height":"30rem","overflow-x":"hidden"} }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row item-poso" }
const _hoisted_9 = {
  key: 1,
  class: "mtop-06"
}
const _hoisted_10 = {
  key: 3,
  class: "w-full col gap-15 mtop-10"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }

import addMedicLine from './addMedicLine.vue'
import editPosologyPreference from './editPosologyPreference.vue'
import editMedicInfo from './editMedicInfo.vue'

import { ref, computed, nextTick, watch, onMounted, onBeforeUnmount } from 'vue'
import SharedService from "@/services/SharedService";
import patientapi from "@/api/patientapi"
import appuserapi from "@/api/appuserapi"
import { useCurrentEntryStore, SapConceptStatus } from '@/stores/currentEntry'
import { useReferenceStore } from '@/stores/reference'
import { useUiStore } from '@/stores/ui'
import gen from "@/functions/general"
import { sortMedicRefList } from "@/functions/medicReference"
import { useAppUserStore } from '@/stores/appUser'

import {
  formatFavoriteFirstPhase, formatFavoriteSuffix, buildFavoriteString, parseFavorite,
  buildDosesFromDoseTimings
} from '@/functions/dosageUtils'
import { findMedicationPreference } from '@/functions/preferenceUtils'
import { useI18n } from 'vue-i18n'
import { splitSuggestions } from '@/functions/documentSuggestions'
import { getSingleElement } from '@/utils/array-utils';
import { useRoute } from 'vue-router';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';


export default /*@__PURE__*/_defineComponent({
  __name: 'editMedicDoseLower',
  props: {
  //conclusionId = important for saving data to the correct correct ccl
  conclusionId: {
    type: String,
    default: '',
  },
  onTreatmentUpdated: {
    type: Function,
    required: false
  },
  onClosed: {
    type: Function,
    required: false
  }
},
  emits: ['close', 'refreshTreatment'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const currentEntryStore = useCurrentEntryStore()
const referenceStore = useReferenceStore()
const uiStore = useUiStore()
const { t } = useI18n()
const toast = useToast();
const route = useRoute();

const props = __props

const emits = __emit

const doses = ref([])
const activeDoseIndex = ref(0)
const inputRefs = ref([])
const daysRefs = ref([])
const dropd = ref(null);
const sapConcept = computed(() => currentEntryStore.sapConcept);

const isNewMedication = ref(currentEntryStore.poppedSapExpr?.isOptimistic === true);

const dosesReady = computed(() =>
  isNewMedication.value ||
  !!currentEntryStore.sapConcept ||
  currentEntryStore.sapConceptStatus === SapConceptStatus.Error
)

const activeDose = computed(() => doses.value[activeDoseIndex.value])

function focusActiveInput() {
  const el = inputRefs.value[activeDoseIndex.value]
  if (el) el.$el.focus()
}

function clearActiveInput() {
  activeDose.value.text = ''
  activeDose.value.days = ''
  activeDose.value.asNeeded = false
  focusActiveInput()
}

function addDoseAfter(i) {
  const idx = i ?? doses.value.length - 1
  const current = doses.value[idx]
  doses.value.splice(idx + 1, 0, { text: current?.text ?? '', days: '', asNeeded: current?.asNeeded ?? false })
  activeDoseIndex.value = idx + 1
  nextTick(() => {
    focusActiveInput()
    const el = inputRefs.value[activeDoseIndex.value]
    if (el) el.$el.select()
  })
}

function removeDose(i) {
  doses.value.splice(i, 1)
  daysRefs.value.splice(i, 1)
  inputRefs.value.splice(i, 1)
  activeDoseIndex.value = Math.min(activeDoseIndex.value, doses.value.length - 1)
}

function addFavoriteToInput(favorite) {
  const parsed = parseFavorite(favorite)
  doses.value = parsed
  activeDoseIndex.value = 0
  nextTick(() => {
    const el = daysRefs.value[0]
    if (el) el.$el.focus()
  })
}

function reloadLastPrescription() {
  const doseTimings = sapConcept.value?.doseTimings
  if (!doseTimings?.length) return
  doses.value = buildDosesFromDoseTimings(doseTimings, currentEntryStore.currentEntryDate)
  activeDoseIndex.value = 0
  nextTick(() => focusActiveInput())
}

function addDynamicSuggestionToInput(newRoute, dosage, brickText = '') {
  activeDose.value.text = brickText
    ? `${dosage.term}: ${brickText}`
    : dosage.term
  if (newRoute !== currentEntryStore.poppedSapNewRouteTerm) {
    currentEntryStore.setPoppedSapNewRouteTerm(newRoute)
    currentEntryStore.setPoppedSapNewGalenic("")
  }
  nextTick(() => {
    if (brickText) {
      const el = daysRefs.value[activeDoseIndex.value]
      if (el) el.$el.focus()
    } else {
      focusActiveInput()
    }
  })
}

function changeRoute(newRoute) {
  activeDose.value.text = ''
  if (newRoute !== currentEntryStore.poppedSapNewRouteTerm) {
    currentEntryStore.setPoppedSapNewRouteTerm(newRoute)
    currentEntryStore.setPoppedSapNewGalenic("")
  }
  focusActiveInput()
}

async function deleteFct() {
  const dashbExpr_CclId = uiStore.dashBoardItem?.expressionCcl?.expressionCclId
  const sapExpr_CclId = currentEntryStore.poppedSapExpr.expressionCcl.expressionCclId
  const entryId = currentEntryStore.currentEntryId

  if (dashbExpr_CclId === sapExpr_CclId) {
    uiStore.clearDashBoard();
  }

  await patientapi.deleteSap(sapExpr_CclId.toString(), entryId, currentEntryStore.poppedSapExpr.patientTreatmentId);

  if (props.onTreatmentUpdated) {
    await props.onTreatmentUpdated();
  }

  currentEntryStore.clearPoppedSapExpr();


  reloadMedicSearchReferences();
  currentEntryStore.reloadAfterMedicationChange();

  emits('close');
}

async function stopSapExprFct() {

  const popped =  currentEntryStore.poppedSapExpr;  
  const expressionCclId = popped?.expressionCcl?.expressionCclId;
  if (!expressionCclId) return

  await patientapi.stopConcept(expressionCclId.toString(), popped.expressionId.toString(), currentEntryStore.currentEntryId, popped.patientTreatmentId);

  currentEntryStore.clearPoppedSapExpr()
  emits('close');

  currentEntryStore.reloadAfterMedicationChange();

  if (props.onTreatmentUpdated) {
    await props.onTreatmentUpdated();
  } else {
    currentEntryStore.setReloadTreatmentData(true);
  }

  if(props.onClosed) {
    props.onClosed();
  }

}

async function closeFct() {
  emits('close');
}


const isSapDeletable = computed(() => {
  if (sapConcept.value) return sapConcept.value.isSapDeletable
  if (currentEntryStore.poppedSapExpr?.isOptimistic) return true
  return false
})

const definingSapExpression = computed(() => {
  return sapConcept.value?.definingSapExpression ?? currentEntryStore.poppedSapExpr
})

const textBricks = [
  "1-0-0",
  "0-0-1",
  "1-0-1",
  "1-1-1",
]

const medicReference = computed(() => {
  if (!definingSapExpression.value) { return; }
  return referenceStore.getMedicReference(definingSapExpression.value.sctSubstanceKey);
})

const sctSubstanceKey = computed(() => {
  return sapConcept.value?.definingSapExpression?.sctSubstanceKey
})

async function handleUpdateSapPatientInfo(payload) {
  // Frontend
  currentEntryStore.patchSapConcept({ patientInfo: payload.patientInfos });
  // Backend
  patientapi.updateSapPatientInfo(payload.conceptGroupId, payload.patientInfos)
}

async function handleUpdateSapPharmacyInfo(payload) {
  // Frontend
  currentEntryStore.patchSapConcept({ pharmacyInfo: payload.pharmacyInfos });
  // Backend
  patientapi.updateSapPharmacyInfo(payload.conceptGroupId, payload.pharmacyInfos)
}

async function handleSaveSuggestionsPreference(payload) {
  await appuserapi.createMedicationSuggestion(payload.newSuggestions, payload.expressionId, payload.originalText)
  await appUserStore.setCurrentAppUserData()
  createList()
}

async function reloadMedicSearchReferences() {
  if (!currentEntryStore.hasCurrentEntry) return;
  const allExpressions = currentEntryStore.patientHistoryResponse;
  referenceStore.createMedicSearchReferences(allExpressions, false, getSingleElement(route.params.patientId))
}


//SUBSTANCES
const favoriteList = ref([])
const sameMonoFamilyList = ref([])
const similarList = ref([])
const moreSubstanceList = ref([])
const lessSubstanceList = ref([])

function createList() {
  if (!currentEntryStore.poppedSapExpr) return
  favoriteList.value = []
  sameMonoFamilyList.value = []
  similarList.value = []
  moreSubstanceList.value = []
  lessSubstanceList.value = []
  // Match favorites for text
  const suggestions = appUserStore.currentAppUserData.preferences.medicationSuggestions || []
  const match = findMedicationPreference(suggestions, currentEntryStore.poppedSapNewName, definingSapExpression.value?.sctSubstanceKey)
  if (match) {
    favoriteList.value = splitSuggestions(match.suggestions);
  }

  // Read substances
  if (!definingSapExpression.value) { console.log("ERROR. NO DEFINING SAP-EXPR"); return }
  const defExpr = definingSapExpression.value
  if (!defExpr.sctSubstanceKey) return

  const sctSubstances = defExpr.sctSubstanceKey.split("-").filter(s => s !== "")
  const substCount = sctSubstances.length
  if (!substCount || !referenceStore.multiSubstanceList) return

  const sctContentFamilies = [
    defExpr.sctContentFamily1, defExpr.sctContentFamily2, defExpr.sctContentFamily3,
    defExpr.sctContentFamily4, defExpr.sctContentFamily5, defExpr.sctContentFamily6,
  ].filter(substance => substance !== "")
  if (sctContentFamilies.length !== substCount) { console.log("Some sctSubstances have no sctContentFamily."); return }

  if (substCount === 1) {
    //Same Family
    const sameMonoFamily = referenceStore.substanceFullList
      .filter(substance => substance.sctContentFamilies[0] === defExpr.sctContentFamily1 && substance.sctSubstanceKey !== defExpr.sctSubstanceKey)
    sortMedicRefList(sameMonoFamily)
    sameMonoFamilyList.value = sameMonoFamily
  } else {
    const similar = referenceStore.multiSubstanceList
      .filter(multiSubstance =>
        multiSubstance.substances.length === substCount &&
        multiSubstance.sctSubstanceKey !== defExpr.sctSubstanceKey &&
        sctContentFamilies.every(family => multiSubstance.sctContentFamilies.includes(family))
      )
    sortMedicRefList(similar)
    similarList.value = similar
  }
  //+n substances
  const moreSubstances = referenceStore.multiSubstanceList
    .filter(multiSubstance => sctSubstances.every(substance => multiSubstance.substances.includes(substance) && substCount < multiSubstance.substances.length))
  sortMedicRefList(moreSubstances)
  moreSubstanceList.value = moreSubstances
  //-n substances
  if (substCount > 1) {
    const lessSolo = referenceStore.substanceFullList
      .filter(substance => sctSubstances.some(curr => curr === substance.sctSubstanceKey.replace(/-----/g, "")))
    const lessMulti = referenceStore.multiSubstanceList
      .filter(multiSubstance => sctSubstances.some(curr => multiSubstance.substances.includes(curr) && substCount > multiSubstance.substances.length))
    const combined = [...lessSolo, ...lessMulti]
    sortMedicRefList(combined)
    lessSubstanceList.value = combined
  }
}

const lastPrescriptionDoses = computed(() => {
  const doseTimings = sapConcept.value?.doseTimings
  if (!doseTimings?.length) return null
  return buildDosesFromDoseTimings(doseTimings, currentEntryStore.currentEntryDate)
})

const lastPrescriptionFavoriteString = computed(() =>
  lastPrescriptionDoses.value ? buildFavoriteString(lastPrescriptionDoses.value, locale.value) : ''
)

const locale = computed(() => {
  return appUserStore?.currentAppUserData?.preferences?.menuLanguageIso || 'fr'
})

watch(
  () => sapConcept.value,
  () => createList(),
  { immediate: true }
)

watch(() => currentEntryStore.sapConceptStatus, (sapConceptStatus) => {
  if (sapConceptStatus === SapConceptStatus.Error) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t('error.DEFAULT')
    })
  }
})

watch(
  () => currentEntryStore.sapConcept,
  (concept) => {
    if (isNewMedication.value) return;
    const doseTimings = concept?.doseTimings;
    doses.value = doseTimings?.length
      ? buildDosesFromDoseTimings(doseTimings, currentEntryStore.currentEntryDate)
      : [{ text: '', days: '', asNeeded: false }]
  },
  { immediate: true }
)

onMounted(() => {
  if (isNewMedication.value) doses.value = [{ text: '', days: '', asNeeded: false }]
  nextTick(() => focusActiveInput())
  setTimeout(reloadMedicSearchReferences, 0)
})

onBeforeUnmount(async () => {
  if (currentEntryStore.poppedSapExpr != null
      && (isNewMedication.value || currentEntryStore.sapConcept)) {
    const newSapExpr = await currentEntryStore.evolveFullSapExpr(doses.value)

    if (newSapExpr) {
      currentEntryStore.updateExpression(newSapExpr);
    }
    currentEntryStore.reloadAfterMedicationChange();
    reloadMedicSearchReferences();

    if (props.onTreatmentUpdated) {
      await props.onTreatmentUpdated();
    } else {
      currentEntryStore.setReloadTreatmentData(true);
    }
    if(props.onClosed) {
      props.onClosed();
    }
  }

})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_switchGroup = _resolveComponent("switchGroup")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_inputBox, {
      style: {"width":"40rem"},
      styles: "pad-none rnd-m"
    }, {
      default: _withCtx(() => [
        (dosesReady.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(doses.value, (dose, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createVNode(_component_text_item, {
                    txt: index > 0 ? _unref(t)('patient.pharmacy.posology.then') : '',
                    class: "main-l font-s pleft-06"
                  }, null, 8, ["txt"]),
                  _createVNode(_component_inputLineNew2, {
                    ref_for: true,
                    ref: el => { if (el) inputRefs.value[index] = el },
                    modelValue: dose.text,
                    "onUpdate:modelValue": ($event: any) => ((dose.text) = $event),
                    styles: "pleft-06",
                    onFocus: ($event: any) => (activeDoseIndex.value = index),
                    onKeyup: _withKeys(($event: any) => (dose.days ? addDoseAfter(index) : null), ["enter"])
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onKeyup"]),
                  _createVNode(_component_switchGroup, {
                    active: dose.asNeeded,
                    class: "psides-06 mright-06",
                    onClick: ($event: any) => (dose.asNeeded = !dose.asNeeded)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.pharmacy.posology.asNeeded'),
                        styles: "font-s",
                        class: _normalizeClass(dose.asNeeded ? 'img-white' : '')
                      }, null, 8, ["txt", "class"])
                    ]),
                    _: 2
                  }, 1032, ["active", "onClick"]),
                  _createVNode(_component_text_item, {
                    txt: index < doses.value.length - 1 ? _unref(t)('patient.pharmacy.posology.during') : _unref(t)('patient.pharmacy.posology.stopIn'),
                    class: "mleft-auto main-m font-s",
                    onFocusCapture: ($event: any) => (activeDoseIndex.value = index)
                  }, null, 8, ["txt", "onFocusCapture"]),
                  _createVNode(_component_inputBox, {
                    style: {"width":"3rem"},
                    class: "mleft-04",
                    onFocusCapture: ($event: any) => (activeDoseIndex.value = index)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_inputLineNew2, {
                        ref_for: true,
                        ref: el => { if (el) daysRefs.value[index] = el },
                        modelValue: dose.days,
                        "onUpdate:modelValue": ($event: any) => ((dose.days) = $event),
                        onKeydown: _unref(gen).onlyInteger,
                        onPaste: _unref(gen).onlyInteger,
                        onKeyup: _withKeys(($event: any) => (dose.days ? addDoseAfter(index) : null), ["enter"])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown", "onPaste", "onKeyup"])
                    ]),
                    _: 2
                  }, 1032, ["onFocusCapture"]),
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.pharmacy.posology.days'),
                    class: "pad-s main-m font-s mleft-04"
                  }, null, 8, ["txt"]),
                  (doses.value.length > 1)
                    ? (_openBlock(), _createBlock(_component_buttonGroup, {
                        key: 0,
                        theme: "inline",
                        onClick: ($event: any) => (removeDose(index)),
                        class: "mleft-04 mright-04"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_item, {
                            icon: "trash",
                            styles: "size-m main-l"
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_buttonGroup, {
                        key: 1,
                        theme: "inline",
                        onClick: clearActiveInput,
                        class: "mleft-04 mright-04"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_item, {
                            icon: "x",
                            styles: "size-m main-l"
                          })
                        ]),
                        _: 1
                      })),
                  _cache[10] || (_cache[10] = _createElementVNode("div", {
                    class: "line-h",
                    style: {"grid-column":"1 / -1"}
                  }, null, -1))
                ], 64))
              }), 128)),
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
                openOn: "EditMedicInfo",
                combo: true,
                style: {"grid-column":"span 2"}
              }, {
                dropd: _withCtx(() => [
                  _createVNode(editMedicInfo, {
                    sapConcept: sapConcept.value,
                    onSavePatientInfos: handleUpdateSapPatientInfo,
                    onSavePharmacyInfos: handleUpdateSapPharmacyInfo
                  }, null, 8, ["sapConcept"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, { class: "w-full pleft-10" }, {
                    default: _withCtx(() => [
                      (sapConcept.value?.patientInfo || sapConcept.value?.pharmacyInfo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (sapConcept.value?.patientInfo)
                              ? (_openBlock(), _createBlock(_component_text_item, {
                                  key: 0,
                                  txt: sapConcept.value.patientInfo,
                                  styles: "font-s main-l",
                                  class: "ellipsis favorite-max-w"
                                }, null, 8, ["txt"]))
                              : _createCommentVNode("", true),
                            (sapConcept.value?.pharmacyInfo)
                              ? (_openBlock(), _createBlock(_component_text_item, {
                                  key: 1,
                                  txt: sapConcept.value.pharmacyInfo,
                                  styles: "font-s main-l",
                                  class: "ellipsis favorite-max-w"
                                }, null, 8, ["txt"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_svg_item, {
                              icon: "plus",
                              styles: "size-m main-l"
                            }),
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('patient.pharmacy.posology.infos'),
                              styles: "font-s main-m",
                              class: "mleft-02"
                            }, null, 8, ["txt"])
                          ], 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _cache[11] || (_cache[11] = _createElementVNode("div", null, null, -1)),
              (doses.value.at(-1)?.days)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_buttonGroup, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (addDoseAfter())),
                      class: "mleft-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          icon: "plus",
                          styles: "size-m main-l"
                        }),
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.pharmacy.posology.sequence'),
                          styles: "font-s main-m",
                          class: "mleft-02"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mtop-08" }, null, -1)),
        _createElementVNode("div", {
          class: "w-full",
          onKeyup: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mtop-10" }, null, -1)),
            (isSapDeletable.value)
              ? (_openBlock(), _createBlock(_component_listGroup2, {
                  key: 0,
                  styles: "pad-m",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteFct()))
                }, {
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "pleft-03" }, null, -1)),
                    _createVNode(_component_svg_item, {
                      icon: "trash",
                      styles: "main-m size-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('action.delete'),
                      class: "mleft-03"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_listGroup2, {
              styles: "pad-m",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (stopSapExprFct()))
            }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "pleft-03" }, null, -1)),
                _createVNode(_component_svg_item, {
                  icon: "stop",
                  styles: "main-m size-s",
                  style: {"margin-top":"-0.25rem","margin-left":"0.05rem"}
                }),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('patient.pharmacy.suggestions.stop'),
                  class: "mleft-05"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mtop-10" }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_text_item, {
                txt: _unref(t)('patient.pharmacy.suggestions.favorites'),
                styles: "main-m",
                class: "mleft-08"
              }, null, 8, ["txt"]),
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mleft-03" }, null, -1)),
              _createVNode(_component_dropdownBox, {
                modelValue: dropd.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
                openOn: "PosoSuggestions",
                combo: true
              }, {
                dropd: _withCtx(() => [
                  _createVNode(editPosologyPreference, {
                    sctSubstanceKey: sctSubstanceKey.value,
                    suggestedFavorite: _unref(buildFavoriteString)(doses.value, locale.value),
                    onSaveSuggestions: handleSaveSuggestionsPreference
                  }, null, 8, ["sctSubstanceKey", "suggestedFavorite"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_buttonGroup, null, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _unref(SharedService).getIcon('gear', false, 'menuIcons'),
                        class: "img-grey h-14 w-14"
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteList.value, (favorite, index) => {
              return (_openBlock(), _createBlock(_component_listGroup2, {
                key: index,
                class: "pad-s row w-full gap-08 pleft-20",
                onClick: ($event: any) => (addFavoriteToInput(favorite.text))
              }, {
                default: _withCtx(() => [
                  (favorite.title)
                    ? (_openBlock(), _createBlock(_component_text_item, {
                        key: 0,
                        txt: favorite.title,
                        class: "item-title txt-primary",
                        styles: "font-m"
                      }, null, 8, ["txt"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_text_item, {
                      txt: _unref(formatFavoriteFirstPhase)(favorite.text, locale.value)
                    }, null, 8, ["txt"]),
                    (_unref(formatFavoriteSuffix)(favorite.text))
                      ? (_openBlock(), _createBlock(_component_text_item, {
                          key: 0,
                          txt: _unref(formatFavoriteSuffix)(favorite.text),
                          class: "main-l mleft-08 no-shrink",
                          styles: "main-l"
                        }, null, 8, ["txt"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128)),
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mtop-10" }, null, -1)),
            (_unref(formatFavoriteFirstPhase)(lastPrescriptionFavoriteString.value, locale.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('patient.pharmacy.suggestions.lastPrescription'),
                    styles: "main-m",
                    class: "mleft-08"
                  }, null, 8, ["txt"]),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
                  _createVNode(_component_listGroup2, {
                    class: "pad-s row w-full gap-08 pleft-20",
                    onClick: reloadLastPrescription
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_text_item, {
                        txt: _unref(formatFavoriteFirstPhase)(lastPrescriptionFavoriteString.value, locale.value)
                      }, null, 8, ["txt"]),
                      (_unref(formatFavoriteSuffix)(lastPrescriptionFavoriteString.value))
                        ? (_openBlock(), _createBlock(_component_text_item, {
                            key: 0,
                            txt: _unref(formatFavoriteSuffix)(lastPrescriptionFavoriteString.value),
                            class: "main-l mleft-08 no-shrink"
                          }, null, 8, ["txt"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "mtop-10" }, null, -1)),
            (medicReference.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(medicReference.value.routeInstructions, (dosages, route, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_listGroup2, {
                      styles: "pad-s pleft-04",
                      class: "row gap-05 pleft-08",
                      onClick: ($event: any) => (changeRoute(route))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: _unref(gen).capitalize(route),
                          styles: "main-m"
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dosages, (dosage, dIdx) => {
                      return (_openBlock(), _createBlock(_component_listGroup2, {
                        key: dIdx,
                        class: "row w-full gap-06 pleft-20",
                        onClick: ($event: any) => (addDynamicSuggestionToInput(route, dosage))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_buttonGroup, { styles: "pad-s" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: dosage.term
                              }, null, 8, ["txt"])
                            ]),
                            _: 2
                          }, 1024),
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mleft-auto" }, null, -1)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(textBricks, (brick, bIdx) => {
                            return _createVNode(_component_buttonGroup, {
                              key: bIdx,
                              styles: "pad-s",
                              onClick: _withModifiers(($event: any) => (addDynamicSuggestionToInput(route, dosage, brick)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_text_item, {
                                  txt: brick,
                                  styles: "main-m"
                                }, null, 8, ["txt"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          }), 64)),
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mleft-15" }, null, -1))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128)),
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mtop-10" }, null, -1))
                  ], 64))
                }), 128))
              : _createCommentVNode("", true),
            (sameMonoFamilyList.value.length || moreSubstanceList.value.length || lessSubstanceList.value.length || similarList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (moreSubstanceList.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.pharmacy.suggestions.moreSubstances'),
                          styles: "main-m",
                          class: "mleft-08"
                        }, null, 8, ["txt"]),
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moreSubstanceList.value, (medic, index) => {
                          return (_openBlock(), _createBlock(addMedicLine, {
                            key: index,
                            content: medic,
                            conclusionId: props.conclusionId,
                            switchMedication: true,
                            class: "medic-indent",
                            onClose: _cache[5] || (_cache[5] = ($event: any) => (closeFct()))
                          }, null, 8, ["content", "conclusionId"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (lessSubstanceList.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.pharmacy.suggestions.lessSubstances'),
                          styles: "main-m",
                          class: "mleft-08"
                        }, null, 8, ["txt"]),
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessSubstanceList.value, (medic, index) => {
                          return (_openBlock(), _createBlock(addMedicLine, {
                            key: index,
                            content: medic,
                            conclusionId: props.conclusionId,
                            switchMedication: true,
                            class: "medic-indent",
                            onClose: _cache[6] || (_cache[6] = ($event: any) => (closeFct()))
                          }, null, 8, ["content", "conclusionId"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (sameMonoFamilyList.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.pharmacy.suggestions.sameFamily'),
                          styles: "main-m",
                          class: "mleft-08"
                        }, null, 8, ["txt"]),
                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sameMonoFamilyList.value, (medic, index) => {
                          return (_openBlock(), _createBlock(addMedicLine, {
                            key: index,
                            content: medic,
                            conclusionId: props.conclusionId,
                            switchMedication: true,
                            class: "medic-indent",
                            onClose: _cache[7] || (_cache[7] = ($event: any) => (closeFct()))
                          }, null, 8, ["content", "conclusionId"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (similarList.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('patient.pharmacy.suggestions.similarComposition'),
                          styles: "main-m",
                          class: "mleft-08"
                        }, null, 8, ["txt"]),
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mtop-01" }, null, -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(similarList.value, (medic, index) => {
                          return (_openBlock(), _createBlock(addMedicLine, {
                            key: index,
                            content: medic,
                            conclusionId: props.conclusionId,
                            switchMedication: true,
                            class: "medic-indent",
                            onClose: _cache[8] || (_cache[8] = ($event: any) => (closeFct()))
                          }, null, 8, ["content", "conclusionId"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ]),
      _: 1
    })
  ]))
}
}

})